'use client';

import type { ReactNode } from 'react';
import { styled } from 'styled-components';

type AccordionListProps = {
  /**
   * Accordion components passed in as children
   */
  children: ReactNode;
  /**
   * Optional class name, nesc. for extending as a styled-component
   */
  className?: string;
};

const AccordionListWrapper = styled.ul`
  border-radius: ${({ theme }) => theme.radius.std};
  box-shadow: 0 1.125em 1.5em 0.625em
    ${({ theme }) => theme.colors.dropShadowBlue};
  height: fit-content;
  margin-top: ${({ theme }) => theme.spacing['1.5']};
  overflow: hidden;
  padding: 0;

  & > :not(:last-child) {
    border-bottom: ${({ theme }) => `1px solid ${theme.colors.grey100}`};
  }

  & > li {
    list-style-type: none;
  }

  ${({ theme }) => theme.mq.minWidth.large} {
    margin: 0;
  }
`;

const AccordionList = ({ children, className }: AccordionListProps) => (
  <AccordionListWrapper className={className}>{children}</AccordionListWrapper>
);

export default AccordionList;
